import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------
// SHIPPING
const ShippingListPage = lazy(() => import('src/pages/shipping/shipping/list'));
const ShippingDetailsPage = lazy(() => import('src/pages/shipping/shipping/details'));
const ShippingCreatePage = lazy(() => import('src/pages/shipping/shipping/new'));
const ShippingEditPage = lazy(() => import('src/pages/shipping/shipping/edit'));
// REPARTIDOR
const CourierListPage = lazy(() => import('src/pages/shipping/courier/list'));
const CourierNew = lazy(() => import('src/pages/shipping/courier/new'));
const CourierEditPage = lazy(() => import('src/pages/shipping/courier/edit'));
// DESPACHADOR
const DispatcherListPage = lazy(() => import('src/pages/shipping/dispatcher/list'));
const DispatcherNew = lazy(() => import('src/pages/shipping/dispatcher/new'));
const DispatcherEditPage = lazy(() => import('src/pages/shipping/dispatcher/edit'));
// PROVIDER
const ProviderListPage = lazy(() => import('src/pages/shipping/provider/list'));
const ProviderNew = lazy(() => import('src/pages/shipping/provider/new'));
const ProviderEditPage = lazy(() => import('src/pages/shipping/provider/edit'));
// DISPATCH
const DispatchListPage = lazy(() => import('src/pages/shipping/dispatch/list'));
const DispatchCreatePage = lazy(() => import('src/pages/shipping/dispatch/new'));
const DispatchDetailsPage = lazy(() => import('src/pages/shipping/dispatch/details'));
const DispatchEditPage = lazy(() => import('src/pages/shipping/dispatch/edit'));
// MASTER DISPATCH
const MasterDispatchListPage = lazy(() => import('src/pages/shipping/master-dispatch/list'));
const MasterDispatchCreatePage = lazy(() => import('src/pages/shipping/master-dispatch/new'));
const MasterDispatchDetailsPage = lazy(() => import('src/pages/shipping/master-dispatch/details'));
const MasterDispatchEditPage = lazy(() => import('src/pages/shipping/master-dispatch/edit'));
// RECEPTOR
const ReceptorListPage = lazy(() => import('src/pages/shipping/receptor/list'));
const ReceptorNew = lazy(() => import('src/pages/shipping/receptor/new'));
const ReceptorEditPage = lazy(() => import('src/pages/shipping/receptor/edit'));
// MANIFEST
const ManifestListPage = lazy(() => import('src/pages/shipping/manifest/list'));
const ManifestCreatePage = lazy(() => import('src/pages/shipping/manifest/new'));
const ManifestDetailsPage = lazy(() => import('src/pages/shipping/manifest/details'));
// RECEPTION
const ReceptionListPage2 = lazy(() => import('src/pages/shipping/reception/list'));
const ReceptionNewPage = lazy(() => import('src/pages/shipping/reception/new'));
const ReceptionDetailsPage2 = lazy(() => import('src/pages/shipping/reception/details'));
// DISTRIBUTOR MANIFEST (slim doc/PDF)
const DistributorManifestDetailsPage = lazy(() => import('src/pages/shipping/distributor-manifest/details'));
const DistributorManifestListPage = lazy(() => import('src/pages/shipping/distributor-manifest/list'));
// DISTRIBUTION (work unit)
const DistributionNewPage = lazy(() => import('src/pages/shipping/distribution/new'));
const DistributionListPage = lazy(() => import('src/pages/shipping/distribution/list'));
const DistributionDetailsPage = lazy(() => import('src/pages/shipping/distribution/details'));
// DISTRIBUTION CLIENT MANAGEMENT
const DistributionClientListPage = lazy(() => import('src/pages/shipping/distribution-client-management/list'));
const DistributionClientNewPage = lazy(() => import('src/pages/shipping/distribution-client-management/new'));
const DistributionClientEditPage = lazy(() => import('src/pages/shipping/distribution-client-management/edit'));
// CLAIM
const ClaimListPage = lazy(() => import('src/pages/shipping/claim/list'));
const ClaimCreatePage = lazy(() => import('src/pages/shipping/claim/new'));
const ClaimDetailsPage = lazy(() => import('src/pages/shipping/claim/details'));
const ClaimEditPage = lazy(() => import('src/pages/shipping/claim/edit'));
// ----------------------------------------------------------------------

export const shippingRoutes = [
  {
    path: 'shipping',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        path: 'courier',
        children: [
          { element: <CourierListPage />, index: true },
          { path: 'list', element: <CourierListPage /> },
          { path: 'new', element: <CourierNew /> },
          { path: ':id/edit', element: <CourierEditPage /> },
        ],
      },
      {
        path: 'dispatcher',
        children: [
          { element: <DispatcherListPage />, index: true },
          { path: 'list', element: <DispatcherListPage /> },
          { path: 'new', element: <DispatcherNew /> },
          { path: ':id/edit', element: <DispatcherEditPage /> },
        ],
      },
      {
        path: 'provider',
        children: [
          { element: <ProviderListPage />, index: true },
          { path: 'list', element: <ProviderListPage /> },
          { path: 'new', element: <ProviderNew /> },
          { path: ':id/edit', element: <ProviderEditPage /> },
        ],
      },
      {
        path: 'shipping',
        children: [
          { element: <ShippingListPage />, index: true },
          { path: 'list', element: <ShippingListPage /> },
          { path: 'new', element: <ShippingCreatePage /> },
          { path: ':clientId/client', element: <ShippingCreatePage /> },
          { path: ':clientId/client/:recipientId/recipient', element: <ShippingCreatePage /> },
          { path: ':id', element: <ShippingDetailsPage /> },
          { path: ':id/edit', element: <ShippingEditPage /> },
        ],
      },
      {
        path: 'dispatch',
        children: [
          { element: <DispatchListPage />, index: true },
          { path: 'list', element: <DispatchListPage /> },
          { path: 'new', element: <DispatchCreatePage /> },
          { path: ':id', element: <DispatchDetailsPage /> },
          { path: ':id/edit', element: <DispatchEditPage /> },
        ],
      },
      {
        path: 'master-dispatch',
        children: [
          { element: <MasterDispatchListPage />, index: true },
          { path: 'list', element: <MasterDispatchListPage /> },
          { path: 'new', element: <MasterDispatchCreatePage /> },
          { path: ':id', element: <MasterDispatchDetailsPage /> },
          { path: ':id/edit', element: <MasterDispatchEditPage /> },
        ],
      },
      {
        path: 'receptor',
        children: [
          { element: <ReceptorListPage />, index: true },
          { path: 'list', element: <ReceptorListPage /> },
          { path: 'new', element: <ReceptorNew /> },
          { path: ':id/edit', element: <ReceptorEditPage /> },
        ],
      },
      {
        path: 'manifest',
        children: [
          { element: <ManifestListPage />, index: true },
          { path: 'list', element: <ManifestListPage /> },
          { path: 'new', element: <ManifestCreatePage /> },
          { path: ':id', element: <ManifestDetailsPage /> },
        ],
      },
      {
        path: 'reception',
        children: [
          { element: <ReceptionListPage2 />, index: true },
          { path: 'list', element: <ReceptionListPage2 /> },
          { path: 'new', element: <ReceptionNewPage /> },
          { path: ':id', element: <ReceptionDetailsPage2 /> },
        ],
      },
      {
        path: 'distribution',
        children: [
          { element: <DistributionListPage />, index: true },
          { path: 'list', element: <DistributionListPage /> },
          { path: 'new', element: <DistributionNewPage /> },
          { path: ':id', element: <DistributionDetailsPage /> },
        ],
      },
      {
        path: 'distributor-manifest',
        children: [
          { element: <DistributorManifestListPage />, index: true },
          { path: 'list', element: <DistributorManifestListPage /> },
          { path: ':id', element: <DistributorManifestDetailsPage /> },
        ],
      },
      {
        path: 'distribution-client',
        children: [
          { element: <DistributionClientListPage />, index: true },
          { path: 'list', element: <DistributionClientListPage /> },
          { path: 'new', element: <DistributionClientNewPage /> },
          { path: ':id/edit', element: <DistributionClientEditPage /> },
        ],
      },
      {
        path: 'claim',
        children: [
          { element: <ClaimListPage />, index: true },
          { path: 'list', element: <ClaimListPage /> },
          { path: 'new', element: <ClaimCreatePage /> },
          { path: ':id', element: <ClaimDetailsPage /> },
          { path: ':id/edit', element: <ClaimEditPage /> },
        ],
      },
    ],
  },
];
